import { authFetchGET } from '../utils/auth-fetch';

const env = (<any>window)["appenv"];

export interface ENCDataInfo {
    lastUpdated: string;
    permitsUpdated: string;
    count: number;
    cells: Array<{
        name: string;
        version: string;
        edition: number;
        update: number;
        compilationScale: number;
        isWithdrawn: boolean;
        unofficial: boolean;
        licenseValid: boolean;
        expires: string;
    }>;
}

export class ENCDataService {
    /**
     * Fetches ENC data information including last update timestamp
     * @returns Promise<ENCDataInfo> containing ENC metadata
     */
    static async getENCData(): Promise<ENCDataInfo> {
        try {
            const tileServerUrl = env.services.encTileServer.baseurl;
            const response = await authFetchGET(
                env.scope,
                `${tileServerUrl}/encdata.json`
            );
            return response;
        } catch (err) {
            console.error('Error fetching ENC data:', err);
            throw err;
        }
    }

    /**
     * Checks if ENC charts are outdated (more than 1 month old)
     * @param lastUpdated - ISO timestamp of last ENC update
     * @returns boolean indicating if charts are outdated
     */
    static isENCOutdated(lastUpdated: string): boolean {
        if (!lastUpdated) return false;
        
        const lastUpdateDate = new Date(lastUpdated);
        const currentDate = new Date();
        const daysSinceUpdate = (currentDate.getTime() - lastUpdateDate.getTime()) / (1000 * 60 * 60 * 24);
        
        // Consider outdated if more than 30 days (1 month)
        return daysSinceUpdate > 30;
    }

    /**
     * Gets the number of days since last ENC update
     * @param lastUpdated - ISO timestamp of last ENC update
     * @returns number of days since update
     */
    static getDaysSinceUpdate(lastUpdated: string): number {
        if (!lastUpdated) return 0;
        
        const lastUpdateDate = new Date(lastUpdated);
        const currentDate = new Date();
        return Math.floor((currentDate.getTime() - lastUpdateDate.getTime()) / (1000 * 60 * 60 * 24));
    }
}
